import { createSlice } from '@reduxjs/toolkit';
import { formatData } from './functions';
import { GlsSkPlacesStateType } from '../../types/glsSkPlaces';

const initialState: GlsSkPlacesStateType = {
    loading: false,
    data: {},
    error: false,
    selectedCountry: null,
};
export const glsSkPlacesSlice = createSlice({
    name: 'glsSkPlaces',
    initialState,
    reducers: {
        getGlsSkPlacesFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getGlsSkPlacesFetchSuccess: (state, action) => {
            state.data[action.payload.country] = formatData(action.payload.data);
            state.loading = false;
        },
        getGlsSkPlacesFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        getGlsSkPlaceByAddressIdFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getGlsSkPlaceByAddressIdFetchSuccess: (state, action) => {
            state.selectedCountry = action.payload.country;
            state.loading = false;
        },
        getGlsSkPlaceByAddressIdFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearSelectedCountry: (state) => {
            state.selectedCountry = null;
        },
    },
});

export const { 
    getGlsSkPlacesFetch, 
    getGlsSkPlacesFetchSuccess, 
    getGlsSkPlacesFetchFailure,
    getGlsSkPlaceByAddressIdFetch,
    getGlsSkPlaceByAddressIdFetchSuccess,
    getGlsSkPlaceByAddressIdFetchFailure,
    clearSelectedCountry,
} = glsSkPlacesSlice.actions;

export default glsSkPlacesSlice.reducer;
